import { ELabelColor, ILabel } from '../../../types/label';
import { IOffer } from '../../../types/offer';

export function getNewbuildingFeaturePromoLabels(offer: IOffer): ILabel[] | null {
  if (!offer.promoInfo) {
    return null;
  }

  return [
    {
      color: ELabelColor.Red,
      text: offer.promoInfo.name,
    },
  ];
}
